import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const VehicleFinancingCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [value, setValue] = useState('50.000,00');
  const [rate, setRate] = useState('1,80');
  const [months, setMonths] = useState('48');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const p = parseFloat(parseBrazilianNumber(value)) || 0;
    const i = (parseFloat(parseBrazilianNumber(rate)) || 0) / 100;
    const n = parseInt(months) || 0;
    if (p <= 0 || i <= 0 || n <= 0) return;

    // Cálculo da prestação (Tabela Price)
    const r = i;
    const installment = p * (r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);
    const totalPaid = installment * n;
    const totalInterest = totalPaid - p;
    const res = { installment, totalPaid, totalInterest };
    setResultState(res);

    onResultChange([
      { label: 'Valor do Veículo', value: `R$ ${p.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Parcela Mensal', value: `R$ ${installment.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Juros Totais', value: `R$ ${totalInterest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` },
      { label: 'Total a Pagar', value: `R$ ${totalPaid.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <FormField label="Valor do Veículo (R$)" value={value} onChange={setValue} required isNumeric type="text" />
          <FormField label="Juros (% a.m.)" value={rate} onChange={setRate} required isNumeric type="text" />
          <FormField label="Prazo (meses)" value={months} onChange={setMonths} required isInteger type="text" step="1" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Financiamento
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <ResultCard title="Parcela" value={`R$ ${resultState.installment.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="indigo" />
            <ResultCard title="Juros Totais" value={`R$ ${resultState.totalInterest.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="amber" />
            <ResultCard title="Total Pago" value={`R$ ${resultState.totalPaid.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}`} color="slate" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Dicas de Financiamento de Veículos"
        tips={[
          'Tente dar a maior entrada possível para reduzir os juros',
          'Considere o CET (Custo Efetivo Total), não apenas a taxa de juros nominal',
          'Lembre-se dos custos extras: IPVA, Seguro e Manutenção',
          'Prazos mais longos resultam em parcelas menores, mas juros muito maiores'
        ]}
      />
    </div>
  );
};

export default VehicleFinancingCalculator;
